// extracted by mini-css-extract-plugin
export default {"shape":"styles_shape__YWiJY"};